import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderDownload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderDownload"><Path d="M16.5 19.5H21.5V6.5H12L10 3.5H2.5V19.5H7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 11.5V17" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 15.5L12 18L9.5 15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFolderDownload;
